import { useTheme } from "next-themes"
import { Toaster as Sonner } from "sonner"
import { toast } from "@/lib/toast"

// One shared Toaster. Anchored to the top-right of the CONTENT area (below the header, so it never
// covers navigation). Each toast is a fully brand-styled panel rendered by @/lib/toast — sonner here
// only handles positioning, stacking (10px gap) and lifecycle. No default chrome (unstyled).
const Toaster = ({
  ...props
}) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme={theme}
      className="os-toaster"
      position="top-right"
      gap={10}
      offset={{ top: "124px", right: "16px" }}
      toastOptions={{ unstyled: true }}
      style={{ "--width": "380px" }}
      {...props} />
  );
}

export { Toaster, toast }
